import { filesForReal } from './filesForReal.js';

/* "Who is this for?" - a manager raising a request for someone below them (Grant, 2026-10-21).
 *
 * The choice is offered only when all three are true: the form allows it (`forSomeoneElse`), the
 * form files for real (lib/filesForReal.js: not in a walkthrough build), and the server listed at
 * least one person below you. Anyone else never sees it. The server checks the reporting line again on every save; this file is
 * only what the screen shows. */

export const offerForSomeone = (type, team, opts) => Boolean(type?.forSomeoneElse && filesForReal(type, opts) && Array.isArray(team) && team.length > 0);

/* The server's refusals of a filing (api/src/functions/tickets.js): of the form itself, of a request
 * for someone else, or of a follow-up. Each one is DEFINITE: the check runs before anything is saved,
 * so "nothing was filed" is true for all of them. NOT_READY is the create's own 503 for a follow-up
 * before 017. INVALID_FORM / UNKNOWN_TYPE are the answers check, run before anything else. */
const REFUSALS = new Set([
  'INVALID_FORM', 'UNKNOWN_TYPE',
  'NOT_ON_YOUR_TEAM', 'NO_WORK_SIGN_IN', 'ON_BEHALF_NOT_ALLOWED', 'ON_BEHALF_UNAVAILABLE', 'LOOKUP_FAILED',
  'FOLLOW_UP_NOT_ALLOWED', 'FOLLOW_UP_NOT_FOR_THEM', 'NOT_CLOSED', 'NOT_READY',
]);

/** The words for a refused request for someone else, or null when the error is something else. */
export function wordsForFilingRefusal(err) {
  if (!err || !REFUSALS.has(err.code)) return null;
  const said = typeof err.serverMessage === 'string' && err.serverMessage.trim() ? err.serverMessage.trim() : 'This could not be raised for that person.';
  return /nothing was filed/i.test(said) ? said : `${said.replace(/\.+$/, '')}. Nothing was filed.`;
}

/** The person picked, from the list the server gave, or null for "me". */
export const personFor = (team, upn) => (upn && Array.isArray(team) ? team.find((p) => p.upn === upn) || null : null);
